import { SET_RESERVATIONHISTORY } from '../actions';

const reservationlist = (state = [], action) => {
  switch (action.type) {
    case SET_RESERVATIONHISTORY:
      return [...action.value];
    default: return state;
  }
}

export default reservationlist;
